import * as actionTypes from 'actions';

const initialState = {
  consolidatedView: true,
};

const consolidatedViewReducer = (state = initialState, action) => {
  if (action.type === actionTypes.SET_CONSOLIDATED_VIEW) {
    return {
      ...state,
      consolidatedView: action.payload,
    };
  } else {
    return state;
  }
};

export default consolidatedViewReducer;
